import 'slick-carousel';
import { homepageBlog } from './custom/blog';
import { homepageFunctions } from './custom/homepage';

import { 
    youtubeFunctions,
    youtubeStateChangeFunctions
} from "./custom/youtube";

jQuery(function() { 
    homepageFunctions();
    youtubeFunctions();  
});

jQuery(window).on('load resize orientationchange', function() {
    youtubeStateChangeFunctions();
    homepageBlog();
});